// Константы для идентификаторов организаций и смежных сущностей
export const CONSTANTS = {
  LEADER_ORG_ID: 1,
  CLAIM_OFFICE_ID: 20,
  ORGANIZATION_TYPE_HR: 275,
} as const

// Константы для типов задач
export const TASK_TYPES = {
  MONTAGE: 'Сделать монтаж',
  MEASUREMENT: 'Сделать замер',
  DELIVERY: 'Сделать доставку',
} as const
